<template>
  <PageContent type="center" :compClass="'flex flex-col space-y-6'">
    <div class="flex flex-row justify-between items-center content-center">
      <h1 class="text-2xl font-medium">
        {{ networkData.name }}
      </h1>
      <Dropdown
        class="ml-4"
        buttonClass="rounded-full flex  text-gray-400 hover:text-gray-600 focus:outline-none z-0"
      >
        <template #trigger>
          <span class="flex items-center h-5 w-5 text-lg">
            <i class="far fa-ellipsis-h transform rotate-90"></i>
          </span>
        </template>
        <template #dropdown>
          <div class="py-1" role="none">
            <button
              class="text-left w-full block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
              role="menuitem"
              v-on:click="editNetwork"
            >
              Edit Network
            </button>
          </div>
        </template>
      </Dropdown>
    </div>
    <div class="flex flex-row justify-between items-center content-center">
      <h1 class="font-medium text-xl">Members</h1>
      <button
        class="bg-blue-600 focus:outline-none px-3 py-1.5 rounded-lg text-white text-sm"
        v-on:click="downloadUsersCsv"
      >
        Export
      </button>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
      <div
        class="col-span-1 bg-white p-3 rounded-lg relative"
        v-for="user in sortedUsers"
        v-bind:key="user.id"
      >
        {{ user.name }}
        <span
          class="bg-red-100 px-2 py-1 rounded-lg uppercase text-xs absolute right-0 mr-4 text-red-800"
          v-if="user.suspended"
          >suspended</span
        >
      </div>
    </div>
    <NetworkEditModal />
  </PageContent>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import PageContent from "@/components/PageContent";
import Dropdown from "@/components/partials/Dropdown";
import NetworkEditModal from "@/screens/admin/modals/NetworkEditModal";

export default {
  name: "AdminNetworkView",
  data() {
    return {
      networkData: {}
    };
  },
  mounted() {
    this.getNetworkData(this.$route.params.id);
    this.$nextTick(
      function() {
        this.$eventBus.$on(
          "admin-network-refresh-data",
          this.getNetworkData(this.$route.params.id)
        );
      }.bind(this)
    );
  },
  components: { PageContent, Dropdown, NetworkEditModal },
  computed: {
    sortedUsers() {
      return this.networkData.users.sort((y, x) => {
        return y.suspended - x.suspended;
      });
    }
  },
  methods: {
    ...mapActions(["addToastMessage"]),
    async getNetworkData(id) {
      const res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/networks/" + id
      );
      this.networkData = res.data;
      this.loading = false;
    },
    async downloadUsersCsv() {
      try {
        let res = await this.$http.get(
          Config.apiPath +
            "/api/v2/admin/networks/" +
            this.$route.params.id +
            "/users/csv",
          {
            responseType: "blob"
          }
        );
        const url = URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "LSM CDN Export - " + this.networkData.name + " - Users.csv"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.addToastMessage({
          title: "Success",
          text:
            "The users have successfully been exported and downloaded as a CSV.",
          type: "success"
        });
      } catch (e) {
        console.log(e);
        this.addToastMessage({
          title: "Error",
          text: "We have encountered an error exportig the users, try again.",
          type: "error"
        });
      }
    },
    editNetwork() {
      this.$eventBus.$emit("admin-edit-network-open-modal", this.networkData);
    }
  }
};
</script>
